module.exports = __webpack_public_path__ + "static/media/JB.97f16de.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/views/NavBar/JB.mp3
// module id = 7R1Y
// module chunks = 19